/**
 * @public
 */ export var TextTrackMimeType = /*#__PURE__*/ function(TextTrackMimeType) {
    TextTrackMimeType["WebVTT"] = "text/vtt";
    TextTrackMimeType["CEA_708"] = "application/cea-708";
    TextTrackMimeType["CEA_608"] = "application/cea-608";
    TextTrackMimeType["TTML"] = "application/ttml+xml";
    return TextTrackMimeType;
}({});

//# sourceMappingURL=text-track-mime-type.js.map